import { getLocalStorageItemAsString, setLocalStorageItem } from '@atlassian/search-common';

export const lightImageKey = 'cachedImageErrorLight';
export const darkImageKey = 'cachedImageErrorDark';

export const fetchAndCacheImage = async (url: string, key: string): Promise<void> => {
	const response = await fetch(url);
	const blob = await response.blob();
	const reader = new FileReader();

	const base64data = await new Promise<string>((resolve, reject) => {
		reader.onloadend = () => {
			resolve(reader.result as string);
		};

		reader.onerror = reject;

		reader.readAsDataURL(blob);
	});

	setLocalStorageItem(key, base64data);
};

export const manageImageCaching = async (
	isOnline: boolean,
	imageLight: string,
	lightImageKey: string,
	imageDark: string,
	darkImageKey: string,
): Promise<void> => {
	if (isOnline) {
		await fetchAndCacheImage(imageLight, lightImageKey);
		await fetchAndCacheImage(imageDark, darkImageKey);
	}
};

export const getCachedImage = (key: string): string | null => {
	return getLocalStorageItemAsString(key);
};
